import React from 'react';

const Gallery = ({ animalType, bio = false, data }) => {
  let images = [];
  if (Array.isArray(data) && data.length > 0) {
    // If data is an array of strings, convert to objects with src and alt
    const lang = (typeof window !== 'undefined' && window.location && window.location.hostname.includes('kaufnekuh')) || (window?.gruttoLang === 'de')
      ? 'https://www.kaufnekuh.de/storage/'
      : 'https://www.grutto.com/storage/';
    if (typeof data[0] === 'string') {
      images = data.map((img, idx) => ({
        src: img.startsWith('http') ? img : lang + img,
        alt: animalType ? `${animalType} image ${idx + 1}` : `Gallery image ${idx + 1}`
      }));
    } else {
      images = data.map(img => ({
        src: img.image_url,
        alt: img.image_alt_text || img.title || 'Gallery image'
      }));
    }
  }

  const wrapperClass =
    'recipe-gallery-wrapper ' +
    animalType +
    (bio ? ' bio' : '') +
    (images.length === 0 ? ' no-images' : '');

  return (
    <div className={wrapperClass}>
      <div className={"recipe-gallery d-none"}>
          {images.map((image, index) => (
              <div key={index} className="itm">
                  <img 
                    src={image.src}
                    alt={image.alt}
                    title={image.alt}
                    className='img-fluid'
                  />
              </div>
          ))}
      </div>
    </div>
  );
};

export default Gallery;